<template>
  <div
    class="tab-group"
    :class="{
      'is-fixed': fixed,
      'is-border': border
    }"
  >
    <ul class="tab-title">
      <li
        v-for="(tabItem, index) in tabs"
        :key="index"
        :class="{ 'is-active': dataSelectedIndex === index }"
        @click="changeTab(index)"
      >
        {{ tabItem.label }}
      </li>
    </ul>
    <div class="tab-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedIndex: {
      type: Number,
      default: 0
    },
    fixed: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tabs: [],
      dataSelectedIndex: this.selectedIndex
    };
  },
  watch: {
    dataSelectedIndex(val, oldVal) {
      this.setTab(oldVal, false);
      this.setTab(val, true);
      this.$emit("update:selectedIndex", val);
      this.$emit("change", val);
    }
  },
  methods: {
    changeTab(index) {
      if (!this.disabled) {
        this.dataSelectedIndex = index;
      }
    },
    setTab(index, show) {
      if (index < this.tabs.length) {
        this.tabs[index].isActive = show;
      }
    }
  },
  mounted() {
    this.tabs = this.$children;
    this.setTab(this.dataSelectedIndex, true);
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/px2rem.scss";

.tab-group {
  &.is-border {
    .tab-title {
      border-bottom: px2rem(20) solid #fafafa;
    }
  }

  &.is-fixed {
    .tab-title {
      position: fixed;
      z-index: 1;
      width: 100%;
      background: #fff;
    }
  }

  .tab-title {
    display: flex;
    padding-top: px2rem(16);
    li {
      flex: 1;
      position: relative;
      text-align: center;
      color: #999;
      &.is-active {
        color: #333;
        &:after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 50%;
          width: px2rem(40);
          height: px2rem(6);
          margin-left: px2rem(-20);
          background: #000;
        }
      }
      display: inline-block;
      box-sizing: border-box;
      cursor: pointer;
      font-size: px2rem(32);
      line-height: px2rem(64);
    }
  }
}
</style>
